/**
 *
 * Dashboard
 *
 */

import React from "react"
import { Helmet } from "react-helmet"
import Layout from "components/Layout"
import { Redirect } from "react-router-dom"
import "../index.less"

/* eslint-disable react/prefer-stateless-function */
export class Dashboard extends React.Component {
  render() {
    return <Redirect to={{ pathname: "/login" }} />
  }
}
export default Dashboard
